export default __webpack_public_path__ + "static/media/home_sm_icon.e8ab37ca.svg";